import { Icon, IconsEnum } from 'components/Icons';
import { BackgroundImage } from 'components/backgroundImage';
import { ChatTrigger } from 'components/chatTrigger';
import { RichText } from 'components/richText';
import { Stepper } from 'components/stepper';
import { StepperProps } from 'components/stepper/Stepper';
import { isSnaiSite } from 'utility/constant';
import styles from './Sidebar.module.scss';

export type SidebarProps = {
  welcomeLabel?: string;
  chatTriggerLabel?: string;
  stepsData: StepperProps['steps'];
  className?: string;
};
export const Sidebar: React.FC<SidebarProps> = ({ stepsData, welcomeLabel, className, chatTriggerLabel }) => {
  return (
    <div className={`${styles.sidebar} ${className}`}>
      <BackgroundImage />
      <div className={styles.stepperContainer}>
        <Stepper steps={stepsData} />
      </div>
      <div className={styles.content}>
        {isSnaiSite && (
          <div className={styles.chat}>
            <ChatTrigger text={chatTriggerLabel} className={styles.trigger} />
          </div>
        )}
        {welcomeLabel && (
          <div className={styles.bonus}>
            <div className={styles.bonusIconContainer}>
              <Icon className={styles.bonusIcon} iconId={IconsEnum.BONUS} color="var(--color-accent)" />
            </div>
            <RichText containerClassName={styles.bonusText}>{welcomeLabel}</RichText>
          </div>
        )}
      </div>
    </div>
  );
};
